import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';

const pdsModalHeaderCss = "pds-modal-header{display:block;width:100%}.pds-modal__header{width:100%}";

const PdsModalHeader$1 = /*@__PURE__*/ proxyCustomElement(class PdsModalHeader extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
    }
    render() {
        return (h("header", { key: '63d1121b84d10ea99354d07b029b7625d52d9095', class: "pds-modal__header" }, h("slot", { key: 'dd08fc600f122e422ccd3161bc558f3b9cc075f9' })));
    }
    static get style() { return pdsModalHeaderCss; }
}, [4, "pds-modal-header"]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["pds-modal-header"];
    components.forEach(tagName => { switch (tagName) {
        case "pds-modal-header":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PdsModalHeader$1);
            }
            break;
    } });
}

const PdsModalHeader = PdsModalHeader$1;
const defineCustomElement = defineCustomElement$1;

export { PdsModalHeader, defineCustomElement };
//# sourceMappingURL=pds-modal-header.js.map

//# sourceMappingURL=pds-modal-header.js.map